<template>
  <div class="relative" v-click-outside="closeDropdwon">
    <div>
      <button class="relative flex items-center focus:outline-none select-none h-full w-full" @click="open = !open">
        <slot name="button"></slot>
      </button>
      <transition
        enter-active-class="transition-all duration-200 ease-out"
        leave-active-class="transition-all duration-750 ease-in"
        enter-class="opacity-0 scale-75"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-75"
      >
        <div v-if="open" :class="placement === 'right' ? 'right-0' : 'left-0'" class="absolute shadow-lg border w-max rounded text-xs bg-white z-50" @click="closeDropdwon()">
          <slot name="content"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  Vue.directive('clickOutside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        if (!(el == event.target || el.contains(event.target)))
          vnode.context[binding.expression](event);
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    },
  });

  export default Vue.extend({
    props: {
      placement: {
        type: String,
        default: 'right',
        validator: (value) => ['right', 'left'].indexOf(value) !== -1,
      },
      idDropdown: String,
    },
    data() {
      return {
        open: false,
        idDrop: '',
      };
    },
    computed: {
      isMenuOpened: function () {
        return this.$store.state.isDropdownOpen;
      },
    },
    methods: {
      openDropdown: function () {
        if (this.$store.state.isDropdownOpen === false) {
          this.open = true;
        }
      },
      closeDropdwon: function () {
        this.open = false;
      },
    },
    mounted() {
      const onEscape = (e) => {
        if (e.key === 'Esc' || e.key === 'Escape') this.open = false;
      };
      if (this.$store.state.isDropdownOpen) {
        this.open = false;
      }

      document.addEventListener('keydown', onEscape);
      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('keydown', onEscape);
      });
    },
  });
</script>



// WEBPACK FOOTER //
// vDropdown.vue?700a3f41